import React, { memo, forwardRef, useContext } from 'react';
import cn from 'classnames';
import { Box } from '../../box';
import { Typography } from '../../typography';
import { Title } from '../Title';
import { Close } from '../close';
import { ModalContext } from '../contexts';
import styles from './styles.module.css';
import baseStyles from '../styles.module.css';
export const Header = memo(forwardRef(function Header({ children, className, title, text, renderTitle, hideClose, ...props }, ref) {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('Modal component has to be placed inside Modal.Overlay');
    }
    const { modalProps: { size }, } = context;
    return (React.createElement(Box, { className: cn(baseStyles.header, styles.header, className), p: size, pb: "s", flexDirection: "column", ...props },
        !hideClose && React.createElement(Close, { className: styles.close }),
        React.createElement(Title, { className: styles.title, variant: "title4", thickness: "medium", color: "main", renderTitle: renderTitle, mb: text ? 's' : undefined }, title),
        !!text && (React.createElement(Typography, { variant: "body2", color: "main" }, text)),
        children));
}));
